import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'
import type { AddressData, PaymentMethod, CheckoutStep } from '../model/types'

interface CheckoutState {
  step: CheckoutStep
  address: AddressData | null
  payment: PaymentMethod
  setStep: (s: CheckoutStep) => void
  setAddress: (a: AddressData) => void
  setPayment: (p: PaymentMethod) => void
  reset: () => void
}

export const useCheckoutStore = create<CheckoutState>()(
  persist(
    (set) => ({
      step: 'review',
      address: null,
      payment: 'cod',
      setStep: (step) => set({ step }),
      setAddress: (address) => set({ address }),
      setPayment: (payment) => set({ payment }),
      reset: () => set({ step: 'review', address: null, payment: 'cod' }),
    }),
    {
      name: 'xedien.checkout.v1',
      storage: createJSONStorage(() => localStorage),
      partialize: (s) => ({ address: s.address, payment: s.payment }),
    },
  ),
)
